import { time } from 'modules/overlay-v2/domain/constants/time';
import { Team } from 'modules/teams/domain/interfaces/team';
import teamsRepository from 'modules/teams/domain/repositories/teams.repository';
import { useQuery, UseQueryOptions } from 'react-query';

export type IUseTeamProps = Omit<UseQueryOptions<Team, unknown, Team, (string | number)[]>, 'queryFn' | 'queryKey'> | undefined;

export function useTeamById(teamId: number, options?: IUseTeamProps) {
  return useQuery(
    ['team', teamId],
    () => {
      return teamsRepository.getTournamentTeam({ teamId });
    },
    {
      enabled: !!teamId,
      staleTime: 2 * time.minute,
      cacheTime: 5 * time.minute,
      retry: 1,
      refetchOnWindowFocus: false,
      ...options,
    },
  );
}
